<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sasAides"
      :show-add-new="sasAides.length < 3"
      :add-new-text="ressourcesByCode('bouton-ajouter-aide')"
      :live="{ endpoint: 'sas-aide', sasId: sas.id }"
      :icon="$getIcon('people')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.prenom }} {{ item.nom }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="aide_prenom" v-model="item.prenom" :live="liveSasAide(8204, item)" />
        <TextFieldLive code="aide_nom" v-model="item.nom" :live="liveSasAide(8205, item)" />
        <DatePickerLive
          code="aide_datedenaissance" 
          v-model="item.dateDeNaissance"
          :live="liveSasAide(8206, item)"
        />
        <CatalogueLive code="aide_sexe" v-model="item.sexe" :live="liveSasAide(8207, item)" />
        <TextFieldLive
          :eudoIf="estSexeIdentifie(item.sexe)"
          code="aide_autre2"
          v-model="item.precisionSexe"
          :live="liveSasAide(8215, item)"
        />
        <CatalogueLive code="aide_problematique" v-model="item.problematiques" :live="liveSasAide(8209, item)" />
        <TextFieldLive
          :eudoIf="estProblematiqueAutre(item.problematiques)"
          code="aide_autre3"
          v-model="item.precisionProblematique"
          :live="liveSasAide(8216, item)"
        />
        <MemoLive code="aide_soutien" v-model="item.descriptionDuSoutien" :live="liveSasAide(8210, item)" />
        <CatalogueLive
          code="aide_lien"
          v-model="item.lienAvecLeProcheAidant"
          :live="liveSasAide(8213, item)"
          :filter="(fd) => filtreLienFamilial(fd)"
        />
        <TextFieldLive
          :eudoIf="estLienAutre(item.lienAvecLeProcheAidant)"
          code="aide_autre1"
          v-model="item.precisionLien"
          :live="liveSasAide(8214, item)"
        />
        <CatalogueLive code="aide_memetoit" v-model="item.demeurezVousSousLeMemeToit" :live="liveSasAide(8211, item)" />
        <DatePickerLive
          code="aide_deces" 
          v-model="item.dateDeDeces"
          :live="liveSasAide(8208, item)"
        />
      </template>
    </data-iterator>
  </v-form>
</template>

<script>

import StepFormWithValidation from "@/components/core/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import { DESC_ID, CODES_CATALOGUES } from "@/constants"
import { mapGetters } from "vuex"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    ...mapGetters(["ressourcesByCode"]),
    sasAides() {
      return this.sas.sasAides
    }
  },
  methods: {
    liveSasAide(cle, item) {
      return { endpoint: "sas-aide", cle: cle, fileId: item.id }
    },
    estSexeIdentifie(value) {
      return this.getCatalogueCodeById(DESC_ID.SEXE, value) == CODES_CATALOGUES.CONTACT_SEXE.JE_M_IDENTIFIE_COMME
    },
    estProblematiqueAutre(value) {
      return value.some((v) => this.getCatalogueCodeById(DESC_ID.PROBLEMATIQUE_PERSONNE_AIDE, v) == CODES_CATALOGUES.PROBLEMATIQUE_PERSONNE_AIDE.AUTRE)
    },
    estLienAutre(value) {
      return this.getCatalogueCodeById(DESC_ID.LIEN_FAMILIAL, value) == CODES_CATALOGUES.LIEN_FAMILIAL.AUTRE
    },
    filtreLienFamilial(fd) {
      return fd.text.includes(CODES_CATALOGUES.FILTRE_LIEN_FAMILIAL_AIDE) || fd.code == CODES_CATALOGUES.LIEN_FAMILIAL.AUTRE
    }
  }
}
</script>

<style></style>
